export default __webpack_public_path__ + "static/meyer-law-gray-28ca02cb9e0ba25e5e790acd60220efc.png";